import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton, ProductImageLink } from './CTAButton';
import { productImage } from '../data/content';
export function Hero() {
  return <header className="bg-brand-navy px-4 py-5 text-center text-white sm:px-6 sm:py-6" data-id="element-84" data-mp="9kjuoj1ugu11">
      <h1 className="mx-auto mb-2 max-w-2xl font-heading text-[24px] uppercase leading-[1.05] sm:text-[40px]" data-id="element-85" data-mp="4lqfmm6wsuyr">
        Le Système Complet de Planification pour les{' '}
        <span className="text-brand-green" data-id="element-86" data-mp="127efjh2kpvf1">Coachs de Padel</span>
      </h1>
      <p className="mx-auto mb-3 max-w-xl text-[13px] font-medium leading-snug text-white/85 sm:text-base" data-id="element-87" data-mp="xbpbp1jitscx">
        Gagnez des heures de préparation chaque semaine grâce à un système professionnel conçu pour
        construire vos séances, organiser vos entraînements, planifier la progression de vos joueurs
        et préparer votre travail avec davantage d&apos;efficacité — sans repartir de zéro avant
        chaque séance.
      </p>
      <ProductImageLink src={productImage} alt="PADEL COACH READY™ — système complet 6-en-1 pour coachs de padel" className="mb-3 max-w-[290px] drop-shadow-[0_16px_36px_rgba(0,0,0,0.5)] sm:max-w-[360px]" data-id="element-88" data-mp="384s5oprwen3l" />
      <div className="mx-auto mb-2 max-w-md" data-id="element-89" data-mp="39b4ib4a0404i">
        <CTAButton data-id="element-90" data-mp="39cflp2zjb5v3">🚀 OUI ! JE VEUX MON SYSTÈME MAINTENANT</CTAButton>
      </div>
      <div className="flex flex-col items-center justify-center gap-0.5 text-[11px] font-bold sm:flex-row sm:gap-4 sm:text-xs" data-id="element-91" data-mp="3e7uvnjuf8hm8">
        <span data-id="element-92" data-mp="30g6m9obk478y">⭐ 4,9/5 — Avis vérifiés de coachs de padel</span>
        <span className="flex items-center gap-1" data-id="element-93" data-mp="359j9bu0l85zl">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-brand-green" aria-hidden="true" data-id="element-94" data-mp="2qk3lalsfyenl" />
          Garantie 7 jours — Zéro risque
        </span>
      </div>
    </header>;
}